import { useQuery } from "@tanstack/react-query";
import { useAuth } from "auth";
import { useSelector } from "react-redux";
import issuer_services from "services/issuer_services";
import {
  networkTypeSelector,
  treasuryIdSelector,
} from "store/userSliceHelpers";

export function useTerminalsCount() {
  const { user } = useAuth();
  const treasuryId = useSelector(treasuryIdSelector);
  const networkType = useSelector(networkTypeSelector);
  return useQuery({
    // Its OWN key. Sharing ["merchantsCount"] with useMerchantsCount made the two one cache
    // entry — whichever queryFn resolved first won, and the other hook rendered the wrong
    // endpoint's payload. treasuryId is in the key because the queryFn reads it.
    queryKey: ["terminalsCount", treasuryId],
    queryFn: () => issuer_services.getTerminalsCount(treasuryId!, networkType),
    enabled: !!user && !!treasuryId,
  });
}
